import { permissoes, routesNames } from '@/core/constants'
import FiscaisView from '@/views/pages/ata/acessar/fiscais/FiscaisView.vue'

export default {
	name: routesNames.ATA.ATA_ACESSAR_FISCAIS_VIEW,
	path: 'fiscais/',
	component: FiscaisView,
	meta: {
		page: {
			title: 'Ata de Registro de Preço',
			subtitle: 'Fiscais',
		},
		requiresAuth: true,
		authorities: [permissoes.ataVisualizar, permissoes.ataEditar],
	},
}
